import {
  PropsWithChildren,
  createContext,
  useEffect,
  useRef,
  useState,
} from 'react';

type BrekpointsContextType = {
  isMobile: boolean;
  isTablet: boolean;
  isOnlyMobile: boolean;
  isOnlyTablet: boolean;
  isOnlyDesktop: boolean;
};

export const BreakpointsContext = createContext<BrekpointsContextType>({
  isTablet: false,
  isMobile: false,
  isOnlyMobile: false,
  isOnlyTablet: false,
  isOnlyDesktop: false,
});

type BreakpointsProviderProps = {};

export function BreakpointsProvider({
  children,
}: PropsWithChildren<BreakpointsProviderProps>) {
  const observerRef = useRef<ResizeObserver>();
  const [value, setValue] = useState<BrekpointsContextType>({
    isTablet: false,
    isMobile: false,
    isOnlyMobile: false,
    isOnlyTablet: false,
    isOnlyDesktop: false,
  });

  useEffect(() => {
    observerRef.current = new ResizeObserver(() => {
      const isMobile = window.matchMedia('(max-width: 480px)').matches;
      const isTablet = window.matchMedia('(max-width: 992px)').matches;
      const isOnlyMobile = isMobile;
      const isOnlyTablet = !isMobile && isTablet;
      const isOnlyDesktop = !isTablet;

      setValue(prev => {
        if (
          prev.isMobile === isMobile &&
          prev.isTablet === isTablet &&
          prev.isOnlyMobile === isOnlyMobile &&
          prev.isOnlyTablet === isOnlyTablet &&
          prev.isOnlyDesktop === isOnlyDesktop
        ) {
          return prev;
        }

        return {
          isTablet,
          isMobile,
          isOnlyMobile,
          isOnlyTablet,
          isOnlyDesktop,
        };
      });
    });

    observerRef.current.observe(document.body);

    return () => observerRef.current?.disconnect();
  }, []);

  return (
    <BreakpointsContext.Provider value={value}>
      {children}
    </BreakpointsContext.Provider>
  );
}
